var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app-shell"},[_c('div',{staticClass:"app-shell__ambient"}),_c('v-main',{staticClass:"app-shell__main"},[_c('router-view',{attrs:{"name":"router1"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }